export default __webpack_public_path__ + "static/media/wellerman.893fb454.png";